import React, { useState } from "react";
import '../Layout/layout.css'
import { Col, Row } from "react-bootstrap";
import ApiService from '../../functions/apiService';
import { useEffect } from "react";
import moment from "moment";
import { toast } from "react-toastify";

const PreAccept = (props) => {
  const { setLoading } = props
  const [list, setList] = useState([])

  const loadData = () => {
    props.setLoading(true)
    ApiService.get('/preAccept')
      .then(({ data }) => {
        console.log(data, '00000000000')
        setList(data?.data)
        props.setLoading(false)
      }).catch(() => {
        props.setLoading(false)
      })
  }

  const saveDetails = async (shift, date, status) => {
    ApiService.post('/makePreAccept', {
      "ShiftCode": shift?.ShiftCode,
      "ShiftDate": date,
      "Action": status
    })
      .then((res) => {
        loadData()
      })
  }

  useEffect(() => {
    loadData()
  }, [])

const PrePosActionRevert = async (shift, date) => {
  try {
    const res = await ApiService.post('/reversePreAccept', {
      ShiftCode: shift?.ShiftCode,
      ShiftDate:  moment(date).format('YYYY-MM-DD'),
    });
    loadData(); 
    toast.success(res.message);
  } catch (error) {
    console.error("Revert API error:", error?.response || error);
    toast.error(error?.response?.data?.message || "Failed to revert action");
  }
};


  return (
    <div>
      {list?.map((item) => (
        <div>
          <div className="date-header mt-4">
            {moment(item?.shiftDate).format('ddd, MMMM DD, YYYY')} (Group {item?.groupName})
          </div>
          {item?.shifts?.map((shift) => (
            <Row className="w-100 p-3" style={{ alignItems: 'center' }}>
              <Col md={1}>
                {shift?.name}
              </Col>
              <Col md={8}>
                {shift?.prevAction && shift?.prevAction != '' ?
                  // <div style={{ color: 'green', textTransform: 'capitalize', fontSize: 13 }}>Pre {shift?.prevAction} submitted</div>
                  <Row className="w-100 align-items-center">
                    <Col md={'auto'}>
                      <div style={{ color: 'green', textTransform: 'capitalize', fontSize: 13 }}>
                        Pre {shift?.prevAction} submitted
                      </div>
                    </Col>

                    {/* ✅ ADD ONLY THIS */}
                    <Col md={'auto'}>
                      <div
                        className="btn-pill"
                        onClick={() => PrePosActionRevert(shift, item?.shiftDate)}
                      >
                        <img
                          src="/images/revert.png"
                          width={22}
                          height={22}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    </Col>
                  </Row>
                  :
                  <Row className="w-100">
                    <Col md={'auto'}>
                      <div className="btn-pill" onClick={() => saveDetails(shift, item?.shiftDate, 'Pre-Accept')}>
                        <img src='/images/check.png' style={{ width: 12, height: 12, marginRight: 10 }} />
                        Pre Accept
                      </div>
                    </Col>
                    <Col md={'auto'}>
                      <div className="btn-pill" onClick={() => saveDetails(shift, item?.shiftDate, 'Pre-Decline')}>
                        <img src='/images/cross.png' style={{ width: 12, height: 12, marginRight: 10 }} />
                        Pre Decline
                      </div>
                    </Col>
                  </Row>
                }
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </div>
  )
}

export default PreAccept